var map = {
	"./Birds/Buntings/Indigo Bunting/Indigo Bunting_1.jpg": 5828,
	"./Birds/Buntings/Indigo Bunting/Indigo Bunting_2.jpg": 9987,
	"./Birds/Buntings/Indigo Bunting/Indigo Bunting_3.jpg": 3526,
	"./Birds/Buntings/Indigo Bunting/Indigo Bunting_4.jpg": 8285,
	"./Birds/Buntings/Painted Bunting/Painted Bunting_21.jpg": 6418,
	"./Birds/Buntings/Painted Bunting/Painted Bunting_29.jpg": 3562,
	"./Birds/Buntings/Painted Bunting/Painted Bunting_30.jpg": 4352,
	"./Birds/Buntings/Painted Bunting/Painted Bunting_31.jpg": 9917,
	"./Birds/Buntings/Painted Bunting/Painted Bunting_5.jpg": 4,
	"./Birds/Buntings/Painted Bunting/Painted Bunting_8.jpg": 9509,
	"./Birds/bkp_icon_1.jpg": 8807,
	"./Birds/icon.jpg": 9837,
	"./Deepspace/Flamingstar and Tadpole Nebula.jpg": 6197,
	"./Deepspace/Horsehead.jpg": 3717,
	"./Deepspace/SH2-284jpg.jpg": 2135,
	"./Deepspace/icon.jpg": 4545,
	"./Landscapes/Waterfalls/Waterfall_1.jpg": 4070,
	"./Landscapes/Waterfalls/Waterfall_2.jpg": 6209,
	"./Landscapes/icon.jpg": 4443,
	"./Macro/Insects/Clay-colored Leaf Beetle.jpg": 6347,
	"./Macro/Insects/Damsel Fly.jpg": 8217,
	"./Macro/Insects/Transparent Quaker Moth.jpg": 6973,
	"./Macro/icon.jpg": 2361,
	"./Nightscapes/IG_VIN9250-Pleaides_WithFG@2x (1).jpg": 3921,
	"./Nightscapes/WM_1Pool_SecretPool (1).jpg": 4786,
	"./Nightscapes/icon.jpg": 6100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8982;